import { FC, memo } from 'react'
import { ProductoInterno } from '../../../../types/responses-novedades'

interface Props {
  producto: ProductoInterno
}

const NovedadImage: FC<Props> = ({ producto: { descripcion, fotoUrl, fotoUrlThumb } }) => {
  return (
    <img
      src={fotoUrlThumb}
      alt={descripcion}
      loading="lazy"
      style={{
        width: '115px',
        height: '115px',
        objectFit: 'cover',
        aspectRatio: '16 / 9',
        borderRadius: '8px'
      }}
    />
  )
}

export default memo(NovedadImage)
